module.exports = "/virtual-football-league/img/video/clubs/england/liverpool.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/video/clubs/england/liverpool.png
// module id = 335
// module chunks = 4